<div class="flex flex-column">
    <div class="flex">
        <app-pessoa-detalhe #pessoaDetalhe [pessoa]="pessoa"></app-pessoa-detalhe>
    </div>

    <div class="flex-grow-1 flex flex-column" style="width: 100vw">
        <div class="grid-debitos flex-grow-1">
            <p-card class="w-full">
                <div class="flex justify-end">
                    <p-select [appendTo]="'body'" [options]="options" [(ngModel)]="selectedComponent" optionLabel="name" placeholder="Selecione" class="w-full md:w-56" />
                </div>
                <div class="content">TODO: implementar</div>
            </p-card>
        </div>
    </div>
</div>
